import { useCallback } from 'react';
import './index.css';

interface Props {
  value: boolean;
  handleValueChange: (value: boolean) => void;
  color: string;
  size: number;
}
const ColoredCheckbox: React.FC<Props> = (props: Props) => {
  const { value, handleValueChange, size, color = 'white' } = props;

  const handleHover = useCallback(
    (e: any) => (e.target.style.background = color),
    [color],
  );

  const handleStopHover = useCallback(
    (e: any) => (e.target.style.background = value ? color : 'transparent'),
    [color, value],
  );

  const handleClick = useCallback(() => {
    handleValueChange(!value);
  }, [handleValueChange, value]);

  return (
    <div
      className="checkbox-container"
      style={{
        width: size,
        height: size,
        borderColor: color,
      }}
      onClick={handleClick}
    >
      <div
        className="checkbox-fill"
        onMouseOver={handleHover}
        onMouseLeave={handleStopHover}
        style={value ? { backgroundColor: color } : {}}
      ></div>
    </div>
  );
};

export default ColoredCheckbox;
